var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSlideIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.879)",
    fill: "#6CC04A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 22.121,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.536 3.3l4.707 4.707-4.707 4.707L38.12 11.3l2.3-2.301-6.3.001V7l6.284-.001-2.284-2.285zm-34.829 0L0 8.007l4.707 4.707L6.121 11.3l-2.3-2.301 6.3.001V7l-6.284-.001 2.284-2.285z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.121,
    cy: 8,
    r: 4
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCA0NiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC44NzkpIiBmaWxsPSIjNkNDMDRBIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxjaXJjbGUgb3BhY2l0eT0iLjQiIGN4PSIyMi4xMjEiIGN5PSI4IiByPSI4Ii8+CiAgICAgICAgPHBhdGggZD0ibTM5LjUzNiAzLjMgNC43MDcgNC43MDctNC43MDcgNC43MDdMMzguMTIgMTEuM2wyLjMtMi4zMDEtNi4zLjAwMVY3bDYuMjg0LS4wMDEtMi4yODQtMi4yODV6TTQuNzA3IDMuMyAwIDguMDA3bDQuNzA3IDQuNzA3TDYuMTIxIDExLjNsLTIuMy0yLjMwMSA2LjMuMDAxVjdsLTYuMjg0LS4wMDEgMi4yODQtMi4yODV6Ii8+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIuMTIxIiBjeT0iOCIgcj0iNCIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconSlideIndicator as ReactComponent };